import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "font-medium text-foreground-700" : ""}>{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}